import PropTypes from 'prop-types'
import classNames from 'classnames'
import Button from '../button'

import Typography from '../typography'
import styles from '../../../styles/bantrab/components/card.module.scss'
import Card from './index'
import Icon from '../icon'
import DownloadFullColorIcon from '../icon/download-full-color.svg'
import Download from '../../bantrab/icon/download.svg'
import AccessTime from '../../bantrab/icon/access_time.svg'

const RecursoLarge = ({ banner, title, date, sales, minutes, ...attrs }) => {
  const { className } = attrs
  attrs.className = classNames(className, {

    [styles.recursoMediun]: true,
    [styles.card]: true
  })

  return (
    <div {...attrs}>

      <Card.Media
        solid
        className={'rounded-bl-lg bg-green-500'}
        background={'black'}
        widgetLeft={
          <Icon
            width='100'
            height='100'
            className={'mt-6 ml-6'}
            svg={DownloadFullColorIcon}
          />
        }
        widgetRight={
          <Typography
            type={'black'}
            size={'five'}
            className={'m-6 w-59'}
          >
            {banner}
          </Typography>
        }
      />
      <Card.Body>
        <div
          className={'flex flex-row justify-between items-center mt-4 font-normal'}
        >
          <div className={'flex flex-row justify-between items-center'}>
            <Typography
              type={'mediun'}
              size={'three'}
              className={'ml-4  mr-6 text-green-500  '}
            >
              {sales}
            </Typography>

            <Typography
              size={'two'}
              className={'mr-4  text-gray-400'}>
              <Icon className={'mr-2.5'} size={24} svg={AccessTime} />
              {minutes}
            </Typography>
          </div>

          <Typography
            size={'two'}
            className={'mr-4  text-gray-400'}>
            {date}
          </Typography>
        </div>
        <div className={'ml-4 mr-16 mb-4 mt-4 '}>
          <Typography
            type={'bold'}
            size={'four'}
            className={'text-$black max-w-big'}
          >
            {title}
          </Typography>
        </div>
        <Button
          className={'w-full'}
          arrow
          background
          href="https://www.google.com"
          iconRight
          target="_blank"

        >
          Descargar
          <Icon className={'ml-2'} size={24} svg={Download} />
        </Button>

      </Card.Body>

    </div>// end div principal
  )
}

RecursoLarge.propTypes = {
  banner: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  date: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  sales: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  minutes: PropTypes.oneOfType([PropTypes.string, PropTypes.node])

}

export default RecursoLarge
